import { ActualItemOrigins } from '../../../common/constants'
import { ActualItem } from '../../../domain/workareaItem'
import { hasValue } from '../../../helpers/nullable'
import { ItemGrouping } from '../grouping'
import { ViewItem } from '../itemModel'

export type InvoiceItemRow = {
  canExpand: boolean
  isChildRow: boolean
  key: string
  itemGuid?: string
  name: string
  numberOfEntries?: number
  origin?: string
  originOwner?: string
  quantity: number
  units: string
  isTaxable?: boolean
  totalPrice: number
}

export const filterWorkareaItems = (workareaItems: ActualItem[]): ActualItem[] => {
  return workareaItems.filter(x => x.isBillable && !hasValue(x.invoiceId))
}

const mapItemGrouping = (group: ItemGrouping): InvoiceItemRow => {
  const numberOfEntries = group.actualItems.length
  const singleItem = numberOfEntries === 1 ? group.actualItems[0] : undefined
  return {
    canExpand: numberOfEntries > 1,
    isChildRow: false,
    key: group.key,
    itemGuid: singleItem?.guid,
    name: group.name,
    numberOfEntries,
    origin: singleItem ? getOrigin(singleItem) : undefined,
    originOwner: singleItem ? getOriginOwner(singleItem) : undefined,
    quantity: group.actualQuantity,
    totalPrice: group.totalActualPrice,
    units: group.units,
    isTaxable: singleItem?.chargeTaxOnInvoice,
  }
}

const mapItem = (item: ViewItem): InvoiceItemRow => {
  return {
    canExpand: false,
    isChildRow: true,
    key: item.guid,
    itemGuid: item.guid,
    name: item.name,
    numberOfEntries: undefined,
    origin: getOrigin(item),
    originOwner: getOriginOwner(item),
    quantity: item.quantity,
    totalPrice: item.totalPrice,
    units: item.units,
    isTaxable: item.chargeTaxOnInvoice,
  }
}

const getOrigin = (item: ViewItem): string | undefined => {
  if (item.origin === ActualItemOrigins.Receipt) {
    return 'Receipt Entry'
  }
  if (item.origin === ActualItemOrigins.Web) {
    return 'Web Entry'
  }
  if (item.visit) {
    const visitDate = new Date(item.visit!.date)
    return `${visitDate.toLocaleDateString('en-US')} visit`
  }
}

const getOriginOwner = (item: ViewItem) => {
  if (item.visit) {
    return item.visit.owner
  }

  return item.originOwner
}

export const mapRows = (groups: ItemGrouping[], expandedRows: string[]): InvoiceItemRow[] => {
  return groups.flatMap(g => {
    const groupRow = mapItemGrouping(g)
    if (groupRow.canExpand && expandedRows.includes(groupRow.key)) {
      return [groupRow, ...g.actualItems.map(mapItem)]
    }

    return [groupRow]
  })
}
